import { format, isValid } from "date-fns";
import { Terminal } from "lucide-react";

export const ExecuteCommandDisplay: React.FC<{
  toolExecution: {
    toolName: string;
    command: string;
    output?: string;
    executedAt: Date;
  };
}> = ({ toolExecution }) => {
  return (
    <>
      {/* Tool Name */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center gap-2">
          <Terminal className="h-4 w-4 text-gray-500" />
          <span className="text-sm text-gray-700">{toolExecution.toolName}</span>
        </div>
      </div>

      {/* Terminal Details */}
      <div className="flex-1 overflow-auto">
        <div className="bg-gray-100 p-4 h-full overflow-auto">
          {/* Terminal Content */}
          <div className="font-mono text-sm">
            <div className="text-green-600 break-all leading-relaxed">
              $ {toolExecution.command}
            </div>
            {toolExecution.output && (
              <div className="mt-2 text-gray-700 whitespace-pre-line break-all">
                {toolExecution.output}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Execution Time */}
      <div className="p-4 border-t border-gray-200 text-xs text-gray-500 text-right">
        実行日時: {isValid(toolExecution.executedAt) && format(toolExecution.executedAt, "yyyy/M/d H:mm")}
      </div>
    </>
  );
};
